import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import gigJobPartiesMixin from './gigJobPartiesMixin'
import statusesMixin from './statusesMixin'
import { readApplications } from '@/api/gigs/applications/applications'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import { CHAT } from '@/constants/routes'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [gigJobPartiesMixin, statusesMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
    }),
    hasDeclineGigByCustomer() {
      return this.isEmployer && !this.isArchived && !this.application?.job
    },
    hasDeclineGigByFreelancer() {
      return (
        this.isWorker && !this.isArchived && !this.application?.job && this.application.offer?.stage !== GigOfferStages.ACCEPTED_BY_CUSTOMER
      )
    },
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
    }),
    ...mapMutations({
      updateApplication: 'gigChat/updateApplication',
    }),
    markApplicationAsRead() {
      if (this.isWorker && !this.application.isRead) {
        readApplications(this.application.id)
        this.updateApplication({ id: this.application.id, isRead: true })
      }
    },
    declineApplicationByFreelancer() {
      this.openModal({
        component: 'lx-lazy-modal',
        props: {
          factory: import(/* webpackChunkName: "job-modals" */ '@/modals/CancelGig/CancelGig.vue'),
          props: {
            applicationId: this.application.id,
            userName: this.application.customer.name,
            onSuccess: () => {
              this.markApplicationAsRead()
              this.$router.push({ name: CHAT })
            },
          },
        },
      })
    },
    declineApplicationByCustomer() {
      this.openModal({
        component: 'lx-lazy-modal',
        props: {
          factory: import(/* webpackChunkName: "job-modals" */ '@/modals/CancelGig/CancelGig.vue'),
          props: {
            applicationId: this.application.id,
            userName: this.application.freelancer.name,
            asCustomer: true,
            onSuccess: () => {
              this.$router.push({ name: CHAT })
            },
          },
        },
      })
    },
  },
})
